<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('createdAt.label')" :columns="6">
        <el-date-picker
                v-model="createdAt"
                type="datetimerange"
                format="dd/MM/yyyy HH:mm"
                start-placeholder="Data Inicial"
                end-placeholder="Data Final">
        </el-date-picker>
      </form-group>

    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      salesChannels: [],
      createdAt: [],
      filters: {
        marketplace: {
          startDate: null,
          endDate: null
        },
        identifier: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.filters.identifier = this.module.identifier

      try {
        let orders = await api.getOrdersList({
          marketplaceIdentifier: this.module.identifier,
          page: 1,
          limit: 1
        })

        if (orders.total <= 0) {
          this.$parent.$parent.canNotSave = true
        } else {
          this.$parent.$parent.canNotSave = false
        }
      } catch (err) {
        this.$parent.$parent.canNotSave = true
      }
    },
    watch: {
      createdAt (value) {
        if (value[0]) {
          this.filters.marketplace.startDate = value[0]
        }

        if (value[1]) {
          this.filters.marketplace.endDate = value[1]
        }
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Sicredi.vue?1cbf841e